

export const SUI_EXPLORER_BASE_URL = "https://sui.scan.space";